import { AppRootState } from '../../../../../../../../store/models/app-state.model';
import { ReviewModel } from '../../../../models/review.model';

export const getReviewsSelector = (state: AppRootState): ReviewModel[] =>
  state.reviews.reviews;
